export { default } from './Accounts';



// WEBPACK FOOTER //
// ./src/components/templates/Accounts/index.js